import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Bottom from "../Bottom";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import noticeimg from "../../assets/images/noticeimg.png";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useEffect } from "react";
import api from "../../utils/api_v2";
import LodingData from "../../utils/LodingData";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';

import tab04 from "../../assets/images/tab_04.png"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import Pagination from 'react-js-pagination';


const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const Notice = () => {
  const navigate = useNavigate();
  const [noticeList, setNoticeList] = React.useState([]);
  const [noticeListParam, setNoticeListParam] = React.useState({ cusId: localStorage.getItem('userCusID'), pageNum: 0, searchWord: '', });
  const [noticeListCount, setNoticeListCount] = React.useState(0);
  const [noticeInfo, setNoticeInfo]: any = React.useState<Record<string, any>>({});

  const updateNoticeListParam = (name: any, value: any) => {
    setNoticeListParam((prev: any) => ({
      ...prev,
      [name]: value,
    }))
  }

  // 모달창
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setTimeout(() => setOpen(true), 100);
  const handleClose = () => setOpen(false);

  let cnt = noticeListParam.pageNum * 10;

  let i = 0;
  useEffect(() => {
    // let params = { cusId: localStorage.getItem('userCusID') || '', pageNum: 0, searchWord: '' };

    // if (params.cusId !== '') {
    //   let i = 0;
    //   while (true) { // 조건문
    //     let listCount = 0;
    //     params.pageNum = i;
    //     api.post(`customer/api/v1/getMobileNoticeList`, params).then(res => {
    //       setNoticeList((prev) => prev.concat(res.data.noticeList));
    //       listCount = res.data.noticeList.length;
    //     }).catch(function (error) {
    //       console.log(error)
    //     });

    //     if (listCount < 1) {
    //       break;
    //     }
    //     i++;
    //   }
    // }

    getNoticeList();

    return () => {
      setNoticeListParam({ cusId: localStorage.getItem('userCusID'), pageNum: 0, searchWord: '', });
    }
  }, []);

  const getNoticeList = () => {
    console.log(noticeListParam);
    LodingData(() => api.post('customer/api/v1/CU_007_001', noticeListParam)
      .then(res => {
        console.log(res);
        setNoticeList(res.data.noticeList);
        setNoticeListCount(res.data.count);
      })
      .catch(err => {
        console.log(err);
      }))
  }

  // 검색 input 핸들러
  const handleSerachInputChange = (e: any) => {
    updateNoticeListParam(e.target.name, e.target.value);
  }

  const handleSearchButton = () => {
    if (noticeListParam.searchWord.length == 1) {
      alert('두 글자 이상 검색어로 입력주세요.');
      return false;
    }

    // updateNoticeListParam('pageNum', 0);
    noticeListParam.pageNum = 0;
    getNoticeList();
  }

  // input 엔터 시
  const handleActiveEnter = (e: any) => {
    if (e.key == 'Enter') {
      handleSearchButton();
    }
  }


  function handlePageChange(page: number) {
    noticeListParam.pageNum = page - 1;
    // updateNoticeListParam('pageNum', page - 1);
    getNoticeList();
  }

  // 1개 항목 클릭 시 게시글 번호 받아 글 상세내용 보내기
  const handleSelectRow = (targetRow: any) => {
    LodingData(() => api.post('customer/api/v1/CU_007_002', { noticeId: targetRow.id })
      .then(res => {
        console.log(res);
        setNoticeInfo(res.data);
      })
      .catch(function (error) {
        console.log(error);
      }));
  }

  // 다운로드 클릭 시
  const handleFileDownload = (noticeId: any, fileName: any) => {
    LodingData(() => api.post('customer/api/v1/CU_007_003', { id: noticeId }, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        const type = res.headers['content-type'];
        const blob = new Blob([res.data], { type: type });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      })
      .catch(err => {
        console.log(err);
      }))
  }


  return (

    <Container className="container">
      <Box sx={img} className='topImg'>
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900 }}>
              이용안내
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              공지사항
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box sx={noticeBox} className='notice_display'>
        {
          noticeList.length <= 0 ? (
            <Box sx={{ textAlign: 'center', mt: 10 }}>
              <CalendarMonthIcon sx={{ fontSize: 50, color: '#999' }} />
              <Typography sx={{ fontSize: 16, color: '#777' }}>
                공지사항이 없습니다.
              </Typography>
            </Box>
          ) : (
            <React.Fragment>
              <Box className="wb_search" sx={{width: 410}}>
                <TextField id="outlined-basic" className='wb_searchinput' variant="outlined" name="searchWord" value={noticeListParam.searchWord} onChange={handleSerachInputChange} onKeyDown={handleActiveEnter} placeholder='제목으로 검색하세요.' size='small' />
                <Button className='search_icon' variant="contained" onClick={handleSearchButton} startIcon={<SearchIcon />}></Button>
              </Box>
              <TableContainer>
                <Table size="small" className="Cl_table" sx={{mt: 2}}>
                  <TableHead>
                    <TableRow>
                      <TableCell>NO</TableCell>
                      <TableCell>제목</TableCell>
                      <TableCell>작성자</TableCell>
                      <TableCell>작성일</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      noticeList && noticeList.map((item: any, idx: any) => (
                        <TableRow key={cnt} hover={true} onClick={() => { handleSelectRow(item); handleOpen(); }}>
                          <TableCell width={50}>{cnt += 1}</TableCell>
                          <TableCell>{item.title}</TableCell>
                          <TableCell width={120}>{item.author}</TableCell>
                          <TableCell width={120}>{item.createDate}</TableCell>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </React.Fragment>
          )
        }
      </Box>

      {/* <Box sx={noticeBox} className='notice_display'>

        {noticeList.map((item: any, index) => (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Stack direction={'column'} >
                <Stack>
                  <Typography sx={noticeTitle}>{item.title}</Typography>
                </Stack>
                <Stack>
                  <Typography sx={noticeDate}><CalendarMonthIcon sx={dateIcon} />{item.createDate}</Typography>
                </Stack>
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={noticeDetail}>
                {item.content}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box> */}

      <Grid container className='foot_list'>
        <Pagination
          activePage={noticeListParam.pageNum + 1} // 현재 페이지
          itemsCountPerPage={10} // 한 페이지에 보여줄 아이템 갯수
          totalItemsCount={noticeListCount} // 총 아이템 갯수
          pageRangeDisplayed={10} // paginator의 페이지 범위
          prevPageText={"‹"} // "이전"을 나타낼 텍스트
          nextPageText={"›"} // "다음"을 나타낼 텍스트
          onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
        />
      </Grid>


      {
        <Dialog
          open={open}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >

          <DialogTitle>
            <Stack direction={'row'}>
              <Typography className="wb_title dialogTitle">공지사항</Typography>
              <Typography sx={{ ml: 'auto', color: '#333', fontSize: 20, cursor: 'pointer', pl: 1 }} onClick={handleClose}>X</Typography>
            </Stack>
          </DialogTitle>
          <Divider />

          <DialogContent sx={{ pb: 3, height: '700px', width: 1000}}>

            <TableContainer>

              <Box sx={{ border: '1px solid #ccc',  borderRadius: 2, position: 'relative'}}>
                <Typography sx={{ fontSize: 18, whiteSpace: 'break-spaces', mt: 3, textAlign: 'center', p: '0px 50px', fontWeight: 700 }}>{noticeInfo && noticeInfo.title}</Typography>

                <Box className='display_flex justifycontent_center alignitem_center' sx={{ borderBottom: '1px solid #ccc', color: '#555', p: 2, '& p': { margin: '0px 10px', fontSize: '14px !important' } }}>
                  <Typography>작성자 : {noticeInfo && noticeInfo.author}</Typography>|
                  <Typography>
                    작성일 :
                    {
                      noticeInfo.createDate && noticeInfo.createDate.indexOf('9999') != -1
                        ? '2020-12-22'
                        : noticeInfo.createDate
                    }
                  </Typography>
                </Box>

                <Box className='display_flex alignitem_center' sx={{ p: 2 }}>
                  <Typography sx={{ marginRight: 1, fontSize: 14 }}>첨부파일 : </Typography>
                  {
                    noticeInfo.fileName == null
                      ? <Typography sx={{ fontSize: 14, color: '#999' }}>첨부파일이 없습니다.</Typography>
                      : <>
                        <Typography sx={{ cursor: 'pointer', fontSize: 14, '&:hover': { textDecoration: 'underline' } }}>{noticeInfo && noticeInfo.fileName}</Typography>
                        <Button className="btn_download" variant="contained" size="small" onClick={() => handleFileDownload(noticeInfo.id, noticeInfo.fileName)}><DownloadIcon sx={{ fontSize: 21 }} /><span style={{ paddingTop: 3 }}>다운로드</span></Button>
                      </>
                  }
                </Box>

                <Box className='' sx={{ borderTop: '1px solid #ccc', color: '#555', p: 2, '& p': { margin: '0px 10px', fontSize: '16px !important' } }}>
                  <Typography sx={{ whiteSpace: 'pre-wrap', p: 5, textAlign: 'left'}}>{noticeInfo && noticeInfo.content}</Typography>
                </Box>
              </Box>

            </TableContainer>

          </DialogContent>

          {/* <Divider />

          <DialogActions>
            <Button sx={{background:'#0d6703', color:'#fff', '&:hover':{background: '#074300'}}} onClick={() => navigate('/Notice/Notice')}>목록</Button>
          </DialogActions> */}

        </Dialog>
      }


      <Bottom />
    </Container>

  );
}


const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tab04})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}

const noticeBox = {
  mb: 4, maxWidth: '100%', width: '80%', mr: 'auto', ml: 'auto',
  boxSizing: 'border-box',
  '& .MuiAccordion-root:first-of-type': { borderTopLeftRadius: 20, borderTopRightRadius: 20, },
  '& .MuiAccordion-root:last-of-type': { borderBottomLeftRadius: 20, borderBottomRightRadius: 20, },
}

const noticeTitle = {
  fontSize: 16,
  fontWeight: 700,
  color: '#555',
  mb: 1,
  pr: 2,
  /*  overflow: 'hidden',
   textOverflow: 'ellipsis',
   display: '-webkit-box',
   '-webkitLineClamp': '2',
   '-webkitBoxOrient': 'vertical' */
}

const noticeDate = {
  fontSize: 13,
  color: '#777'
}

const dateIcon = {
  fontSize: 16,
  color: '#888',
  verticalAlign: 'sub',
  mr: '5px'
}

const noticeDetail = {
  fontSize: 16,
  color: '#555',
  whiteSpace: 'pre-wrap'
}

export default Notice;